define(function (require) {
    "use strict";

    var LE = require("app");

    var ValidationUtilities = require("utils/ValidationUtilities");

    var WidgetParametersModel = require("personalization-web-agent-models/WidgetParametersModel");

    var WidgetParametersCollection = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetParametersCollection = Backbone.Collection.extend({
            model : WidgetParametersModel,
            validate : function () {
                var errors = {};

                this.validateDuplicates();

                _.each(this.models, function(model) {
                    var modelErrors = model.validate();
                    if (modelErrors) {
                        errors[model.id] = modelErrors;
                    }
                });

                return errors;
            },

            validateDuplicates: function() {
                //clear
                _.each(this.models, function(model) {
                    model.errors.withinListDuplicated = false;
                });

                //find duplicates
                var duplicatedItems = ValidationUtilities.findDuplicationsInCollection(this,
                    function(model1, model2){
                        return model1.get("name") === model2.get("name");
                    });

                //mark them up
                _.each(duplicatedItems, function(duplicatedModel) {
                    duplicatedModel.errors.withinListDuplicated = true;
                });
            }
        });
    });
    return WidgetParametersCollection;
});
